import React, { createContext, useContext, useState, ReactNode } from 'react';
import { inviteContextType, inviteData, QuizAnswer } from './types';

const InviteContext = createContext<inviteContextType | undefined>(undefined);

export const InviteProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [userData, setUserData] = useState<inviteData | null>(null);
  const [step, setstep] = useState<number>(1);
  const [formFillstatus, setFormFillStatus] = useState<string>('');
  const [quizAnswers, setQuizAnswers] = useState<QuizAnswer[]>([]);

  const nextStep = () => setstep(prev => prev + 1);
  const prevStep = () => setstep(prev => (prev > 1 ? prev - 1 : 1));

  const setUserField = (field: keyof inviteData, value: string) => {
    setUserData(prevData =>
      prevData ? { ...prevData, [field]: value } : null,
    );
  };
  const updateQuizAnswer = (
    id: string,
    answer: string | string[],
    isMultiple: boolean,
  ) => {
    setQuizAnswers(prevAnswers => {
      const existing = prevAnswers.find(q => q.id === id);
      if (existing) {
        // Update existing answer
        return prevAnswers.map(q =>
          q.id === id ? { id, answer, isMultiple } : q,
        );
      }
      // Add new answer
      return [...prevAnswers, { id, answer, isMultiple }];
    });
  };

  const getQuizAnswer = (id: string) => {
    return quizAnswers.find(quiz => quiz.id === id);
  };

  const clearUserData = () => setUserData(null);

  return (
    <InviteContext.Provider
      value={{
        userData,
        setUserData,
        setUserField,
        clearUserData,
        step,
        nextStep,
        prevStep,
        formFillstatus,
        setFormFilling: setFormFillStatus,
        quizAnswers,
        updateQuizAnswer,
        getQuizAnswer,
      }}
    >
      {children}
    </InviteContext.Provider>
  );
};

export const useInvite = (): inviteContextType => {
  const context = useContext(InviteContext);
  if (!context) {
    throw new Error('useInvite must be used within an InviteProvider');
  }
  return context;
};
